module.exports = __webpack_public_path__ + "img/10.25cd7c88.png";